import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import LinkCell from 'components/TrapsTables/Cells/LinkCell/LinkCell';
import DeviceLinkCell from 'components/TrapsTables/Cells/LinkCell/DevicesLinkCall';
import { TrapData } from 'api/traps/Hubs/types';
import { TrapTableTypeLink } from 'components/TrapsTables/trapTables';

interface HubDetailSBSExpandableProps {
  data: TrapData;
  slug?: string;
  deviceType?: TrapTableTypeLink;
}
const HubDetailSBSExpandable: React.FC<HubDetailSBSExpandableProps> = ({ data, slug, deviceType }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex w-100 flex-column border">
      <div className="d-flex flex-wrap gap-2 justify-content-around my-2 border-bottom">
        <div>
          <span className="me-1 fs-14 fw-bold">{t('TrapTables.Number')}</span>
          <div className="my-2">
            <LinkCell
              title={String(data.sequence_number) || 'None'}
              link={`/trap/info/${data.slug}`}
              toReact
              icon="ri-eye-line"
            />
          </div>
        </div>

        <div>
          <span className="me-1 fs-14 fw-bold pb-3">{`${t('TrapTables.LastConnection')}: `}</span>
          <div className="my-2">
            {dayjs(data?.last_connect).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')
              ? dayjs(data?.last_connect).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')
              : '-'}
          </div>
        </div>
      </div>

      <div className="d-flex flex-wrap justify-content-around my-2">
        <div>
          <span className="me-1 fs-14 fw-bold">{t('TrapTables.InteractiveMap')}</span>
          <div className="my-2">
            <DeviceLinkCell
              data={data.default_plan ?? null}
              icon="ri-treasure-map-line"
              slug={slug}
              deviceType={deviceType}
              device_add_slug={data.slug}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubDetailSBSExpandable;
